import { createRoute, lazyFn } from '@tanstack/react-router';

import { NotFoundPage } from '$/pages/NotFoundPage';
import { RootRoute } from '$/routes/RootRoute';

export const AdminBaseRouteLayout = createRoute({
  notFoundComponent: NotFoundPage,
  getParentRoute: () => RootRoute,
  beforeLoad: lazyFn(
    () => import('./AdminBaseRouteLayout.lazyFn'),
    'beforeLoad',
  ),
  onLeave: () => {
    location.reload();
  },
  id: 'adminBaseLayout',
}).lazy(() => import('./AdminBaseRouteLayout.lazy').then((d) => d.Route));
